import './index.less'
import { getServerTime } from '@utils/api.js';

if (!customElements.get('app-text-promotion-fold')) {
  customElements.define('app-text-promotion-fold', class AppTextPromotionFold extends HTMLElement {
    constructor() {
      super();

      // 展开区容器
      this.unfoldWrap = this.querySelector('.text-promotion-content')

      // 倒计时容器
      this.countdownWrap  = this.querySelector('.text-promotion-countdown')

      // 折叠区容器
      this.foldWrap = this.querySelector('.text-promotion-fold-content')

      this.isShowArrow = this.countdownWrap.getAttribute('data-show-arrow') === 'true'

      if (this.unfoldWrap) {
        const {
          shopifyTimeStr, endsInText,
          countdownStartStr, countdownEndStr, countdownTextColor,
          countdownNumberBgColor, countdownNumberColor,
        } = this.unfoldWrap.dataset;
    
        this.i18nText = {
          endsInText,
          countdownTextColor,
          countdownNumberBgColor,
          countdownNumberColor,
        };
    
        const currentTime = new Date(shopifyTimeStr).getTime();
        this.startTime = new Date(countdownStartStr || 0).getTime();
        this.endTime = new Date(countdownEndStr || 0).getTime();
    
        this.countdownStatus = this.checkCountDownStatus(currentTime, this.startTime, this.endTime);
        if (this.countdownStatus) {
          this.initCountDownDOM();
    
          // 开始倒计时
          this.tick(currentTime, this.endTime);
    
          // 监听tab页签或窗口激活状态，重新刷新倒计时
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          window.addEventListener('focus', this.handleWindowFocus);
        }
        // 无倒计时
        else {
          // 渲染 箭头
          if (this.isShowArrow && (this.unfoldWrap?.dataset?.hasFoldText === 'true' || this?.unfoldWrap?.dataset?.hasBgImg === 'true')) {
            this.countdownWrap.innerHTML = this.renderCountDownDOM(false);
            if (this?.unfoldWrap?.dataset?.hasBgImg === 'false') {
              this.countdownWrap.style.backgroundColor = 'var(--block-bg-color)';
              this.foldWrap && (this.foldWrap.querySelector('.jds-rte').style.paddingTop = '8px');
            } else {
              this.countdownWrap.style.backgroundColor = 'transparent';
              this.foldWrap && (this.foldWrap.querySelector('.jds-rte').style.paddingTop = '0');
            }
            this.initCountDownClickEvent()
          }
        }
      }
    }
    connectedCallback() {
      
    }
    disconnectedCallback() {
      // 元素被移除时，取消初始化
      this.destroy();
    }
    // 判断倒计时状态
    checkCountDownStatus(currentTime, startTime, endTime) {
      let flag = false;
      if (!startTime && endTime) {
        // 只有结束时间，判断当前时间是否小于结束时间
        if (currentTime < endTime) {
          flag = true;
        } else {
          flag = false;
        }
      } else if (startTime && endTime) {
        // 有开始时间和结束时间，则判断当前时间在不在开始时间和结束时间之间
        if (currentTime >= startTime && currentTime < endTime) {
          flag = true;
        } else {
          flag = false;
        }
      } else {
        // 只有开始时间，不展示UI
        flag = false;
      }
      return flag;
    }
    // 初始化 倒计时 DOM
    initCountDownDOM() {
      this.countdownWrap.innerHTML = this.renderCountDownDOM(true);
  
      // 倒计时 DOM
      this.daysDOM = this.countdownWrap.querySelector('[data-countdown-days]');
      this.hrsDOM = this.countdownWrap.querySelector('[data-countdown-hrs]');
      this.minsDOM = this.countdownWrap.querySelector('[data-countdown-mins]');
      this.secsDOM = this.countdownWrap.querySelector('[data-countdown-secs]');

      this.initCountDownClickEvent()
    }
    // 初始化 倒计时 点击事件
    initCountDownClickEvent() {
      if (this.isShowArrow) {
        const arrowBtn = this.countdownWrap.querySelector('[data-arrow-btn]');
        arrowBtn && arrowBtn.addEventListener('click', () => {
          if (this.foldWrap?.clientHeight > 0) {
            this.foldWrap && (this.foldWrap.style.height = '0px');
          } else {
            this.foldWrap && (this.foldWrap.style.height = this.foldWrap.scrollHeight + 'px');
          }
          arrowBtn.querySelector('svg').classList.toggle('rotate-180');
        })
      }
    }
    // 倒计时计数
    tick(currentTime, endTime) {
      const leftTime = (endTime - currentTime) / 1000;
      let days, hours, minutes, seconds;
  
      if (leftTime <= 0) {
        this.timer && clearTimeout(this.timer);
  
        // 清空倒计时DOM
        this.querySelector('.text-promotion-countdown').innerHTML = '';
      } else {
        days = String(parseInt(leftTime / 60 / 60 / 24)).padStart(2, '0');
        hours = String(parseInt(leftTime / 60 / 60 % 24)).padStart(2, '0');
        minutes = String(parseInt(leftTime / 60 % 60)).padStart(2, '0');
        seconds = String(parseInt(leftTime % 60)).padStart(2, '0');
  
        this.daysDOM.innerText = days;
        this.hrsDOM.innerText = hours;
        this.minsDOM.innerText = minutes;
        this.secsDOM.innerText = seconds;
  
        this.timer = setTimeout(() => this.tick(currentTime + 1000, endTime), 1000);
      }
    }
    // 渲染 倒计时 DOM
    renderCountDownDOM(showCountdown) {
      const arrowHTML = this.isShowArrow ? `
        <div class="flex-1 flex items-center justify-end cursor-pointer pr-[0.9375rem] lg:pr-5 ${!showCountdown && this?.unfoldWrap?.dataset?.hasBgImg === 'false' ? '-mt-[0.8125rem] pb-[0.375rem] lg:pb-[0.25rem] lg:-mt-[1rem]' : ''}" data-arrow-btn>
          <svg class="w-[0.875rem] h-[1.25rem] lg:w-[1rem] lg:h-[1.25rem] transition-all duration-300" width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <path d="M27.88 40.753a2.3 2.3 0 001.686-.734l19.487-20.07a2.22 2.22 0 00.68-1.62c0-.44-.1-.836-.302-1.19a2.228 2.228 0 00-.818-.835A2.265 2.265 0 0047.442 16c-.621 0-1.167.22-1.637.658L26.52 36.475h2.694L9.928 16.658A2.268 2.268 0 008.29 16c-.436 0-.827.101-1.17.304-.345.202-.617.48-.819.835-.201.354-.302.75-.302 1.19a2.287 2.287 0 00.68 1.645l19.487 20.045c.504.489 1.074.734 1.712.734z" fill="#666666" fill-rule="nonzero"></path>
              <path d="M0 0h56v56H0z"></path>
            </g>
          </svg>
        </div>
      ` : '';

      if (!showCountdown) {
        if (this?.unfoldWrap?.dataset?.hasBgImg === 'true') {
          return `
            <div class="flex items-center justify-between pl-[1.125rem] py-[0.6875rem] lg:pl-6 lg:py-[0.625rem]">
              ${arrowHTML}
            </div>
          `
        }
        return arrowHTML
      }

      const daysItem = this.renderTimeItem('days');
      const HrsItem = this.renderTimeItem('hrs');
      const MinsItem = this.renderTimeItem('mins');
      const secsItem = this.renderTimeItem('secs');

      return `
        <div class="flex items-center justify-between pl-[1.125rem] py-[0.6875rem] lg:pl-6 lg:py-[0.625rem]">
          <div class="flex">
            <div class="font-medium max-w-[10rem] text-[0.75rem] leading-[1.125rem] mr-[0.5rem] line-clamp-1 lg:max-w-[18.75rem] lg:text-[0.8125rem] lg:leading-[1.25rem] lg:mr-2" style="color:${this.i18nText.countdownTextColor}">${this.i18nText.endsInText}</div>
            <div class="flex flex-col">
              <div class="flex items-start justify-center">
                ${daysItem}
                <span class="flex items-center justify-center font-semibold w-[0.5rem] h-[1rem] text-[0.75rem] leading-[1rem] lg:min-w-[0.375rem] lg:h-[1.125rem] lg:text-[0.8125rem]" style="color:${this.i18nText.countdownTextColor}">:</span>
                ${HrsItem}
                <span class="flex items-center justify-center font-semibold w-[0.5rem] h-[1rem] text-[0.75rem] leading-[1rem] lg:min-w-[0.375rem] lg:h-[1.125rem] lg:text-[0.8125rem]" style="color:${this.i18nText.countdownTextColor}">:</span>
                ${MinsItem}
                <span class="flex items-center justify-center font-semibold w-[0.5rem] h-[1rem] text-[0.75rem] leading-[1rem] lg:min-w-[0.375rem] lg:h-[1.125rem] lg:text-[0.8125rem]" style="color:${this.i18nText.countdownTextColor}">:</span>
                ${secsItem}
              </div>
            </div>
          </div>
          ${arrowHTML}
        </div>
      `;
    }
    // 渲染单个的 item
    renderTimeItem(name) {
      return `
        <span
          class="block text-center font-semibold min-w-[1.5rem] h-[1.125rem] text-[0.75rem] leading-[1.1875rem] px-[0.25rem] rounded-[0.09375rem] lg:min-w-[1.5rem] lg:h-[1.25rem] lg:text-[0.8125rem] lg:leading-[1.3125rem] lg:px-[0.1875rem] lg:rounded-[0.125rem]"
          style="color:${this.i18nText.countdownNumberColor};background-color:${this.i18nText.countdownNumberBgColor}"
          data-countdown-${name}
        ></span>
      `;
    }
    // 监听页面可见性（页面激活：标签页切换回来）
    handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        this.resumeActivities();
      }
    }
    // 监听窗口焦点（整个浏览器窗口 窗口激活）
    handleWindowFocus = () => {
      this.resumeActivities();
    }
    // 获取服务器时间
    async fetchServerTime() {
      const { data, } = await getServerTime();
      const serverTime = new Date(data.datetime).getTime();
      this.countdownStatus = this.checkCountDownStatus(serverTime, this.startTime, this.endTime);
  
      // 清空 倒计时 DOM
      this.countdownWrap.innerHTML = '';
  
      if (this.countdownStatus) {
        // 初始化倒计时DOM
        this.initCountDownDOM();
  
        // 开始倒计时
        clearTimeout(this.timer);
        this.tick(serverTime, this.endTime);
      } else {
        this.destroy();

        if (this.isShowArrow && (this.unfoldWrap?.dataset?.hasFoldText === 'true' || this?.unfoldWrap?.dataset?.hasBgImg === 'true')) {
          // 渲染 箭头
          this.countdownWrap.innerHTML = this.renderCountDownDOM(false);
          if (this?.unfoldWrap?.dataset?.hasBgImg === 'false') {
            this.countdownWrap.style.backgroundColor = 'var(--block-bg-color)';
            this.foldWrap && (this.foldWrap.querySelector('.jds-rte').style.paddingTop = '8px');
          } else {
            this.countdownWrap.style.backgroundColor = 'transparent';
            this.foldWrap && (this.foldWrap.querySelector('.jds-rte').style.paddingTop = '0');
          }
          this.initCountDownClickEvent()
        }
      }
    }
    resumeActivities = () => {
      // 确保当前的倒计时是有效的，然后再统一处理激活状态逻辑
      if (this.countdownStatus) {
        this.fetchServerTime();
      }
    }
    // 建议添加清理方法
    destroy() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('focus', this.handleWindowFocus);
    }
  })
}
